// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"070a3864","7679":"1f09ee9f"}[chunkId] + ".chunk.css";
};